import React, { useState } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { PayloadStates } from '@lore/utils';
import moment from 'moment-timezone';
import colors from 'tailwindcss/colors';
import LineChart from '@/pages/dashboard/_charts/LineChart';
import ChartLoader from '@/pages/dashboard/_charts/ChartLoader';
import usePartnerEventEvaluations from '@/features/dashboard-eval/hooks/usePartnerEventEvaluations';
import useCompletedPartnerEventEvaluations from '@/features/dashboard-eval/hooks/useCompletedPartnerEventEvaluations';

PartnerEventEvaluationsByMonth.propTypes = {
  state: PropTypes.string,
  network: PropTypes.shape({ id: PropTypes.number }),
  timestamps: PropTypes.array,
  empty: PropTypes.func
};

export default function PartnerEventEvaluationsByMonth(props) {
  const { state, network, timestamps, empty } = props;

  const [currentTimestamp] = useState(moment().toISOString());

  const educators = timestamps.map(function(timestamp) {
    if (moment(currentTimestamp).diff(timestamp.start) < 0) {
      return {
        ...timestamp,
        results: {
          created: empty(),
          completed: empty()
        }
      }
    }

    return {
      ...timestamp,
      results: {
        created: usePartnerEventEvaluations({ state, network, schoolStart: timestamp.start, schoolEnd: timestamp.end }),
        completed: useCompletedPartnerEventEvaluations({ state, network, schoolStart: timestamp.start, schoolEnd: timestamp.end })
      }
    }
  });

  const loading = _.reduce(educators, function(result, educator) {
    return (
      result ||
      educator.results.created.state === PayloadStates.FETCHING ||
      educator.results.completed.state === PayloadStates.FETCHING
    );
  }, false)

  if (loading) {
    return (
      <ChartLoader
        title="Event Evaluations: Partners"
        subtitle="Over school year"
      />
    );
  }

  const series = [
    {
      name: 'Evaluations (Sent)',
      data: educators.map(e => e.results.created.meta.totalCount)
    },
    {
      name: 'Evaluations (Completed)',
      data: educators.map(e => e.results.completed.meta.totalCount)
    }
  ];

  return (
    <LineChart
      title="Completion rates for event evaluations sent to partners"
      subtitle="Over school year"
      labels={educators.map(e => e.label)}
      series={series}
      colors={[
        colors.blue['400'],
        colors.emerald['400'],
        colors.yellow['400']
      ]}
    />
  );
}
